<template>
<b-container fluid>
    <b-row class="fixed-bar">
    <b-col class="hd" cols="12"><ActionBar/></b-col> 
        <b-col cols="7">
          <br>
          <RecoverSalesOrder/>
          <ItemSearch/>          
          <ItemM3 v-if="this.$store.state.itemproperties.itemno != ''"/>
          <ModalBox/>
          <voucherModal v-if="this.$store.state.voucherModal == 1"/>
        </b-col>    
    </b-row>    
    <br>
     <b-row class="under-topbar justify-content-md-end">
        <b-col class = "cart" cols="5">
          <OrderType/>
          <CustSelect/>
          <SalesHeader/>
          <ShoppingCart/>
          <PosTotals/>
        </b-col>        
    </b-row>
</b-container>
</template>

<script>
// @ is an alias to /src
import ItemSearch from '@/components/ItemSearch.vue'
import CustSelect from '@/components/CustSelect.vue'
import ShoppingCart from '@/components/ShoppingCart.vue'
import PosTotals from '@/components/Totals.vue'
import ActionBar from '@/components/ActionBar.vue'
import RecoverSalesOrder from '@/components/RecoverSalesOrder.vue'
import ItemM3 from '@/components/ItemM3.vue'
import OrderType from '@/components/OrderType.vue'
import SalesHeader from '@/components/SalesHeader.vue'
import ModalBox from '@/components/ModalBox.vue'
import voucherModal from '@/components/VoucherModal.vue'


export default {
  name: 'Pos',
  components: {
    ItemSearch,
    ShoppingCart,
    CustSelect,
    PosTotals,
    ActionBar,
    RecoverSalesOrder,
    ItemM3,
    OrderType,
    SalesHeader,
    ModalBox,
    voucherModal
  }
}
</script>
<style scoped>
.fixed-bar {
  position: fixed;
  top: 0;
  z-index: 1;
  width: inherit;
  max-width: inherit;
  height: 1px;
}
.under-topbar {
  margin-top: 56px; 
  z-index: 0;
}
.SB{
  background-color: green;
  height: 30px;
}
</style>
